import React from 'react';

import block from 'propmods';

import './HostItem.scss';

const bi = block('HostItem');

interface Props {
    host: string;
}

export const HostItem: React.FC<Props> = ({ host }) => (
    <div {...bi()}>
        <div {...bi('host')}>{host}</div>
    </div>
);
